const Section = ({ title, children }) => {
  return (
    <div className="bg-white border rounded-2xl p-5 shadow-sm">
      <h3 className="font-black text-slate-800 mb-4">{title}</h3>
      {children}
    </div>
  );
};

export default Section;
